import Panoviewer from './Panoviewer'

export default Panoviewer
